import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { toast } from 'sonner';
import { templatesNewService } from '../services/templatesNew.service';
import type { TemplateRecord, TemplateType, TemplateStatus } from '../../list/types/templates.types';

export function useTemplatesNew() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
    type: 'report' as TemplateType,
    status: 'active' as TemplateStatus,
  });

  const mutation = useMutation({
    mutationFn: (data: any) => templatesNewService.createTemplate({
      ...data,
      companyId: profile?.company_id,
      createdBy: profile?.id,
    }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'templates', 'list'] });
      toast.success('Đã tạo mẫu tài liệu mới');
      navigate('/settings/templates');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Không thể tạo mẫu tài liệu');
    }
  });

  const handleNameChange = (name: string) => {
    // Tự động tạo mã từ tên: "Phân & thuốc" -> "Phan-Thuoc"
    const slug = name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[đĐ]/g, 'd')
      .replace(/([^0-9a-zA-Z-\s])/g, '')
      .replace(/(\s+)/g, '-')
      .replace(/-+/g, '-')
      .toUpperCase();

    setFormData(prev => ({ ...prev, name, code: slug }));
  };

  return {
    formData,
    setFormData,
    handleNameChange,
    isSaving: mutation.isPending,
    createTemplate: () => mutation.mutate(formData),
  };
}
